import React from "react"
import { Container, Row, Col, Form } from "react-bootstrap"
import useForm from "../useForm"
import { titleOptions } from "../../data/formOptions"

const MultiPerson = props => {
  const { values, handleChange: formHandleChange, addValidationError, removeValidationError } = props

  const handleBlur = e => {
    handleChange(e)
  }

  const handleChange = e => {
    formHandleChange(e)
    if (isValid(e)) {
      removeValidationError(e.target.name)
    }
  }

  const isValid = e => {
    const { name, value } = e.target
    if (name === "firstName" && !value) {
      addValidationError("Enter your first name", name)
      return false
    }
    if (name === "lastName" && !value) {
      addValidationError("Enter your last name", name)
      return false
    }
    
    return true
  }

  return (
    <div>
      <Container>
        <Row className="justify-content-center">
          <Col>
            {/* <Form autoComplete="on"> */}
              {/* <---------------SECOND ROW--------------->*/}
              <Form.Row>
                <Form.Group as={Col} controlId="title" xs={12} sm={4}>
                  <div className="row-question">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      as="select"
                      name="title"
                      value={values.title}
                      onChange={handleChange}
                      className="select"
                    >
                      {titleOptions.map(({ value, formattedValue }) => (
                        <option key={value} value={value}>
                          {formattedValue}
                        </option>
                      ))}
                    </Form.Control>
                  </div>
                </Form.Group>
                <Form.Group as={Col} controlId="firstName" xs={12} sm={4}>
                  <div className="row-question">
                    <Form.Label>First name</Form.Label>
                    <Form.Control
                      className="text-field"
                      as="input"
                      name="firstName"
                      placeholder="First name"
                      onChange={handleChange}
                      value={values.firstName}
                      onBlur={handleBlur}
                      type="text"
                      required
                      autoComplete="given-name"
                    ></Form.Control>
                  </div>
                </Form.Group>
                <Form.Group as={Col} controlId="lastName" xs={12} sm={4}>
                  <div className="row-question">
                    <Form.Label>Last name</Form.Label>
                    <Form.Control
                      className="text-field"
                      as="input"
                      name="lastName"
                      value={values.lastName}
                      placeholder="Last name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      type="text"
                      required
                      autoComplete="family-name"
                    ></Form.Control>
                  </div>
                </Form.Group>
              </Form.Row>
            {/* </Form> */}
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default MultiPerson
